import { NETWORK_VALUE_BY_WRAPPED_NETWORK_VALUE } from '@/constants/NETWORK_NAMES';

export const isWrappedNetwork = (netValue: string) => {
  const wrappedNetValue = NETWORK_VALUE_BY_WRAPPED_NETWORK_VALUE[netValue];
  return netValue !== wrappedNetValue;
};
